import {CommunityTaskGroup} from "../../../hooks/useGetLevels";
import {useAppDispatch, useAppSelector} from "../../../redux/hooks";
import {Select, SelectChangeEvent, Typography} from "@mui/material";
import {levelSlice} from "../../../redux/store";
import MenuItem from "@mui/material/MenuItem";
import React from "react";

export default function SelectTaskGroup(props: {taskGroups: CommunityTaskGroup[]}) {
    const taskGroup = useAppSelector(s => s.levels.currentTaskGroup)
    const dispatch = useAppDispatch()

    const saveTaskState = useAppSelector(s => s.levels.unsavedTask)
    const saveLevelState = useAppSelector(s => s.levels.unsavedLevel)
    const saveTaskGroupState = useAppSelector(s => s.levels.unsavedTaskGroup)

    const val = taskGroup === null ? "-1" : taskGroup.groupId
    const setVal = (e: SelectChangeEvent) => {
        const toSet = props.taskGroups.find(s => s.groupId === parseInt(e.target.value))
        if (toSet === undefined) {
            return;
        }
        if(saveTaskState) {
            dispatch(levelSlice.actions.setSaveTaskStatus(true))
        }
        else if(saveTaskGroupState) {
            dispatch(levelSlice.actions.setSaveTaskGroupStatus(true))
        }
        else if(saveLevelState) {
            dispatch(levelSlice.actions.setSaveLevelStatus(true))
        }
        else {
            dispatch(levelSlice.actions.setCurrentTaskGroup(toSet))
        }

    }
    if (!props.taskGroups) {
        return <>
            <Typography sx={{fontSize: 13}} color="text.secondary" gutterBottom>
                <i>No Task Groups available</i>
                <br/>
                <i>Start by creating one</i>
            </Typography>
        </>
    }

    return <Select value={val.toString()} onChange={setVal}>
        <MenuItem disabled value={val}><i>Select a Task Group</i></MenuItem>
        {
            props.taskGroups.map((v, k) => {
                return <MenuItem key={k} value={v.groupId}>
                    {v.groupName}
                </MenuItem>
            })
        }
    </Select>
}